<template>
  <b-modal id="modal-nova-corretora" size="lg" title="Adicionar corretora" @ok="save" ok-title="Salvar" ok-only
    :ok-disabled="!canSave">
    <div class="mb-3">
      <label class="dbo-ui">Nome da Corretora</label>
      <b-form-select v-model="form.broker_id">
        <b-form-select-option v-for="option in brokerOptions" :key="option.value" :value="option.value"
          :disabled="usedBrokers.includes(option.value)">
          {{ option.text }}
        </b-form-select-option>
      </b-form-select>
    </div>

<div class="row">
  <div class="col-12 col-lg-12">
    <label class="dbo-ui mb-2" for="produtos_ativos">Produtos ativos</label>
    <div class="form-group">
      <div class="row">
        <div class="col-12 col-lg-6" v-for="type in insuranceTypes" :key="type.id">
          <label
            class="card card-body border shadow p-3 d-block check-card mb-2"
            style="flex: 0 0 calc(100%); cursor: pointer;"
            :title="disabledTypes.includes(type.id) ? 'Este produto já está ativo em outra corretora' : ''"
          >
            <input
              type="checkbox"
              class="form-control"
              :id="'produto_' + type.id"
              :value="type.id"
              :disabled="disabledTypes.includes(type.id)"
              v-model="form.insurance_type_ids"
              style="margin-right: 8px; width: auto;"
            >
            <div class="pl-1 d-inline">{{ type.name }}</div>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

    
  </b-modal>
</template>

<script>
export default {
  props: {
    brokerOptions: Array,
    insuranceTypes: Array,
    usedTypes: Array,
    usedBrokerIds: {
      type: Array,
      default: () => []
    },
    initialForm: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    initialForm: {
      handler(newVal) {
        if (newVal) {
          this.form = { ...newVal };
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      form: {
        broker_id: null,
        insurance_type_ids: [],
      },
    };
  },
  computed: {
    disabledTypes() {
      if (!this.form.broker_id) return this.usedTypes ?? [];

      return (this.usedTypes ?? []).filter((typeId) => {
        return !this.initialForm?.insurance_type_ids?.includes(typeId);
      });
    },
    usedBrokers() {
      return this.usedBrokerIds ?? [];
    },
canSave() {
  const isEditingSameBroker =
    this.initialForm &&
    this.initialForm.broker_id === this.form.broker_id;

  return (
    this.form.broker_id !== null &&
    this.form.insurance_type_ids.length > 0 &&
    (!this.usedBrokers.includes(this.form.broker_id) || isEditingSameBroker)
  );
}

  },
  methods: {
    save() {
      this.$emit('save-broker-insurance', this.form);
      this.form = { broker_id: null, insurance_type_ids: [] };
    },
  },
};
</script>
